// extracted by css-extract-rspack-plugin
export default {"badge":"FMw6d","StyledLastEditInfoLabel":"qBRlJ","StyledQuestionDataSource":"RiN7y"};